import moment from 'moment'

export const contractColors = {
  CDI: '#108ee9',
  CDD: '#00bcd4',
  STAGE: '#ff5722',
  ALTERNANCE: '#673ab7c7',
  INTERIM: '#87d068',
  TRANSITION_MANAGEMENT: '#eccc68',
  default: 'blue',
}

export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

moment.locale('fr', {
  months:
    'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
      '_',
    ),
  monthsShort:
    'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
  monthsParseExact: true,
  weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
  weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
  weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
  },
  calendar: {
    sameDay: '[Aujourd’hui à] LT',
    nextDay: '[Demain à] LT',
    nextWeek: 'dddd [à] LT',
    lastDay: '[Hier à] LT',
    lastWeek: 'dddd [dernier à] LT',
    sameElse: 'L',
  },
  relativeTime: {
    future: 'dans %s',
    past: 'il y a %s',
    s: 'quelques secondes',
    m: 'une minute',
    mm: '%d minutes',
    h: 'une heure',
    hh: '%d heures',
    d: 'un jour',
    dd: '%d jours',
    M: 'un mois',
    MM: '%d mois',
    y: 'un an',
    yy: '%d ans',
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal(number) {
    return number + (number === 1 ? 'er' : 'e')
  },
  meridiemParse: /PD|MD/,
  isPM(input) {
    return input.charAt(0) === 'M'
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem(hours) {
    return hours < 12 ? 'PD' : 'MD'
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // Used to determine first week of the year.
  },
})

/**
 * Generate offer url depending on application type
 * @param {Object} offer
 * @returns {String} offer url
 */
export const generateSoftApplyUrl = (offer) => {
  if (Object.keys(offer).length === 0) return undefined

  const baseURL = process.env.REACT_APP_APPLY_URL || 'http://localhost:3002'
  return `${baseURL}/soft/${offer._id}?companyId=${offer.company_id}&teamId=${offer.team_id}`
}

export const generateJ2BDSoftApplyUrl = (offer) => {
  if (Object.keys(offer).length === 0) return undefined

  const baseURL = 'https://job2bedone-partners-app.hollo.io'
  return `${baseURL}/soft/${offer._id}?companyId=${offer.company_id}&teamId=${offer.team_id}`
}

export const remote = (target, t) => {
  switch (target) {
    case 'FULL':
      return t('campaign:offer.remoteWorking.full')
    case 'PARTIAL':
      return t('campaign:offer.remoteWorking.partial')
    case 'PUNCTUAL':
      return t('campaign:offer.remoteWorking.punctual')
    case 'UNAUTHORIZED':
      return t('campaign:offer.remoteWorking.unauthorized')
    default:
      return 'Pas de précision'
  }
}

export const remoteOptions = (t) => [
  { value: 'FULL', label: t('campaign:offer.remoteWorking.full') },
  { value: 'PARTIAL', label: t('campaign:offer.remoteWorking.partial') },
  { value: 'PUNCTUAL', label: t('campaign:offer.remoteWorking.punctual') },
  {
    value: 'UNAUTHORIZED',
    label: t('campaign:offer.remoteWorking.unauthorized'),
  },
]

export const experienceOptions = (t) => ({
  junior: t('common:exp.junior'),
  intermediate: t('common:exp.intermediate'),
  senior: t('common:exp.senior'),
  expert: t('common:exp.expert'),
  moreThanTen: t('common:exp.moreThanTen'),
})

export const schoolLevelOptions = (t) => [
  { value: '2', label: t('common:bac2') },
  { value: '3', label: t('common:bac3') },
  { value: '4', label: t('common:bac4') },
  { value: '5', label: t('common:bac5') },
  { value: 'above', label: t('common:bacAbove') },
]

export const experienceOptionsFilters = (t) => [
  { label: t('common:exp.junior'), value: 'junior' },
  { label: t('common:exp.intermediate'), value: 'intermediate' },
  { label: t('common:exp.senior'), value: 'senior' },
  { label: t('common:exp.expert'), value: 'expert' },
  { label: t('common:exp.moreThanTen'), value: 'moreThanTen' },
]
